import type { ContentsquareTrackingIdentifier } from '@shared/analytics/types/contentsquare'

export const contentsquare = {
  /**
   * Generates a unique identifier to use
   * as class for tracking purpose
   */
  getTrackingDataAttributes: (identifier: ContentsquareTrackingIdentifier) =>
    ({
      'data-cs-track': identifier,
    }) as const,
}
